import React from "react";
import { IReactSelectOption } from "../models/ReactSelect.models";
import Select from "react-select";
import { EmptyFormikMultiselect } from "src/shared/components/EmptyFormikMultiselect";

interface Props {
  fieldName: string;
  label: string;
  options: IReactSelectOption[];
  defaultValues: IReactSelectOption[];
  setFieldValue: any;
  loading: boolean;
  loadingOptions: boolean;
  view?: boolean;
  onCreateOption?: (value: string) => void;
}

export const CustomFormikMultiselect = React.memo(
  ({
    fieldName,
    label,
    options,
    defaultValues,
    setFieldValue,
    loading,
    loadingOptions,
    view,
    onCreateOption,
  }: Props) => {
    if (options?.length === 0) {
      return (
        <EmptyFormikMultiselect
          label={label}
          loading={loading}
          loadingOptions={loadingOptions}
          onCreateOption={onCreateOption}
        />
      );
    }

    return (
      <div>
        <label htmlFor="choices-multiple-default" className="form-label">
          {label}
        </label>
        <Select
          id={fieldName}
          name={fieldName}
          isMulti
          options={options}
          placeholder={`Seleccionar ${label}..`}
          className="basic-multi-select"
          classNamePrefix="select"
          value={defaultValues} // change defaultValue to value so the select can clear normaly https://stackoverflow.com/questions/67732619/clear-a-specific-select-in-react-bootstrap
          onChange={(event: any) => {
            setFieldValue(
              fieldName,
              event.map(o => o.value)
            );
          }}
          //styles={customStyles}
          isDisabled={loading || loadingOptions || view}
          isLoading={loading || loadingOptions}
          menuPortalTarget={document.body} // Render the dropdown menu in the body
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Ensure the dropdown menu is above other elements
          // formatCreateLabel={(value: string) => {
          //   return `Agregar "${value}"`;
          // }}
          // onCreateOption={onCreateOption}
        />
      </div>
    );
  }
);
